import helper from '@/api/helper';
import config from '@/configs/config';

const API_ENDPOINT = `${config.API_ENDPOINT}/externalApi-preOrderCommand`;

const DEFAULT_QUERY = {
  env: process.env.REACT_APP_MODE,
};

const getInfo = ({ query = {} }) => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'getInfo',
    ...query,
  },
});

const getGroupPreOrder = ({ query = {} }) => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'getGroupPreOrder',
    ...query,
  },
});

const createGroupPreOrder = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'createGroupPreOrder',
    ...query,
  },
  body,
});

const createLinePayRequestInfo = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'preOrderRequestLinePay',
    ...query,
  },
  body,
});

const createTapPay3DRequestInfo = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'preOrderRequestTapPay3D',
    ...query,
  },
  body,
});

const confirmTapPay3DRequestInfo = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'preOrderConfirmRequestTapPay3D',
    ...query,
  },
  body,
});

const checkout = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'preOrderCheckout',
    ...query,
  },
  body,
});

const sendVerificationCode = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'startRegister',
    ...query,
  },
  body,
});

const verifyVerificationCode = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'registerVerifyCode',
    ...query,
  },
  body,
});

const getPersonalPreOrderList = ({ query = {} }) => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'getPersonalPreOrderList',
    ...query,
  },
});

const getPersonalPreOrderDetail = ({ query = {} }) => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'getPersonalPreOrderDetail',
    ...query,
  },
});

const getWatchedPreOrderList = ({ query = {} }) => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'getWatchedPreOrderListByIds',
    ...query,
  },
});

const checkMagicCode = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'checkMagicCode',
    ...query,
  },
  body,
});

const redeem = ({ query = {}, body = {} }) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'redeem',
    ...query,
  },
  body,
});

export default {
  getInfo,
  getGroupPreOrder,
  createGroupPreOrder,
  createLinePayRequestInfo,
  createTapPay3DRequestInfo,
  confirmTapPay3DRequestInfo,
  checkout,
  sendVerificationCode,
  verifyVerificationCode,
  getPersonalPreOrderList,
  getPersonalPreOrderDetail,
  getWatchedPreOrderList,
  checkMagicCode,
  redeem,
};
